export default function userDirective() {
  return {
    template: require('./user.html'),
    restrict: 'E',
    controller: 'UserController',
    controllerAs: 'userVM',
    bindToController: true,
    replace: true,
    scope: {
      customerId: '@',
      customerHasUnverifiedEmailDomain: '@',
      visibleCustomerCount: '@',
      user: '=',
      searchText: '=',
    },
  };
}
